import { render, staticRenderFns } from "./DevelopersNav.vue?vue&type=template&id=58840247&"
import script from "./DevelopersNav.vue?vue&type=script&lang=js&"
export * from "./DevelopersNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports